export default __webpack_public_path__ + "static/media/icon-insights-performance-return-customers.89cee595.svg";